export default __webpack_public_path__ + "static/media/ic_map_asia_hub.d0b348d1.svg";